import { stringifyGraph } from '@/clients/http'
import { CouponModel } from '@/http/models/Coupon'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { CouponHttpParams, CouponModel as CouponModelType, CouponResponses } from '@/types'

export interface CouponListFilters {
  search?: string
  status?: 'active' | 'inactive' | 'expired' | null
}

export interface CouponListForm extends UseFetchListForm<
  CouponListFilters,
  CouponModelType.Coupon
> {}

interface UseFetchCouponsProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const couponInitialFilters: CouponListFilters = {
  search: '',
  status: null,
}

export const useFetchCoupons = ({ sort, shouldFetchList }: UseFetchCouponsProps) => {
  return useFetchList<
    CouponListFilters,
    CouponModelType.Coupon,
    {},
    any,
    typeof CouponModel.getList
  >({
    pageSize: 10,
    initialFilters: couponInitialFilters,
    fetchFunction: CouponModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<CouponHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
